import React, { useState} from "react";
import { Autocomplete, TextField } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

const ProductComponent = ({ products, OnProductChange }) => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const matchesMobileWidth = useMediaQuery("(max-width:1032px)");

  const handleSelectedProduct = (event, value) => {
    setSelectedProduct(value);
    OnProductChange(value);
  };

  const getTextFieldInputProps = (params, errorMessageElementId, ) => { 
    return matchesMobileWidth ? {
      inputProps: {
        ...params.inputProps,
        onBlur: undefined,
        "aria-errormessage": errorMessageElementId,
        "aria-invalid": !selectedProduct
      }
    } : {
      inputProps: {
      ...params.inputProps,
      "aria-errormessage": errorMessageElementId,
      "aria-invalid": !selectedProduct
    }
  };
};
  
  return (
    <>
      {products?.length > 1 && (
        <Autocomplete
          className="norstella-cf-ProductText"
          disablePortal
          selectOnFocus
          handleHomeEndKeys
          disableClearable
          id="productSelect"
          options={products}
          value={selectedProduct}
          onChange={handleSelectedProduct}
          renderInput={(params) => 
            <TextField 
              {...params} 
              placeholder={selectedProduct ? "" : "Select Product"}
              {...getTextFieldInputProps(params, "divProductMessage")}
              />}
          getOptionLabel={(option) => option.Name}
          part="cfProductSelect" />
      )}
    </>
  );
};

export default ProductComponent;
